// The operations routes, grouped so router.tsx gains one import and three spreads: Desk (a mode),
// Setup › Add-ons, Billing and Costs, and the operator console's failed events, DE list and
// Billing (WALLET-P1).
import { deskRoute } from "./c.$slug.desk";
import { setupAddonsRoute } from "./c.$slug.setup.addons";
import { setupBillingRoute } from "./c.$slug.setup.billing";
import { setupCostsRoute } from "./c.$slug.setup.costs";
import { companySystemAgentRoute } from "./c.$slug.system-agents.$id";
import { operatorBillingRoute } from "./operator.billing";
import { operatorOnboardingCaseRoute, operatorOnboardingRoute } from "./operator.onboarding";
import {
  operatorAgentHealthRoute,
  operatorAgentHealthTopicRoute,
  operatorClientsRoute,
  operatorConnectionsRoute,
  operatorConsumersRoute,
  operatorDesRoute,
  operatorGuardsRoute,
  operatorMemoryQualityRoute,
  operatorOpportunitiesRoute,
  operatorSatellitesRoute,
  operatorSkillProposalRoute,
  operatorSkillProposalsRoute,
  operatorSkillsmithClientRoute,
  operatorSkillsmithRoute,
  operatorSystemAgentSpaceRoute,
  operatorSystemAgentsRoute,
} from "./operator.ops";
import { operatorSettingsRoute } from "./operator.settings";

export const opsOperatorRoutes = [
  // SUPER-ADMIN: the operator workspace's clients
  operatorClientsRoute,
  // ONBOARDING-P3: the onboarding cases and one case
  operatorOnboardingRoute,
  operatorOnboardingCaseRoute,
  // SKILLSMITH-CONTROL: pick a client, open its Skillsmith
  operatorSkillsmithRoute,
  operatorSkillsmithClientRoute,
  operatorConsumersRoute,
  operatorDesRoute,
  operatorSystemAgentsRoute,
  operatorSystemAgentSpaceRoute,
  operatorAgentHealthRoute,
  operatorOpportunitiesRoute,
  operatorAgentHealthTopicRoute,
  operatorSkillProposalsRoute,
  operatorSkillProposalRoute,
  operatorMemoryQualityRoute,
  operatorConnectionsRoute,
  operatorSatellitesRoute,
  operatorGuardsRoute,
  operatorBillingRoute,
  operatorSettingsRoute,
] as const;
export const opsCompanyRoutes = [deskRoute, companySystemAgentRoute] as const;
export const opsSetupRoutes = [setupAddonsRoute, setupBillingRoute, setupCostsRoute] as const;
